export const search = {
  'Top Result': 'Resultado más relevante',
  Songs: 'Canciones',
  Song: 'Canción',
  Albums: 'Álbumes',
  Album: 'Álbum',
  Artists: 'Artistas',
  Artist: 'Artista',
  By: 'Por',
  'Browse all': 'Explorar todo',
  Playlists: 'Playlists',
  'Clear recent searches': 'Borrar búsquedas recientes',
  'Recent Searches': 'Búsquedas recientes',
  // 'No results': 'No results',
  // 'No results where found for': 'No results where found for',
  'No results': 'No se encontraron resultados',
  'No results where found for': 'No se encontraron resultados para',
};
